import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SidebarItem } from '../sidebar-item';

import { Item, MENU_OPTIONS } from '@/data/menu-options';
import { useUserPermissions } from '@/hooks/use-user-permissions';

export const MenuList: FC<{ isNarrowBar: boolean }> = (props) => {
    const {
        isCampaignsAdmin,
        isMyBotsAdmin,
        isCallAnalyticsEnabled,
        isChatAnalyticsEnabled,
        isSmsAnalyticsEnabled,
        isVoicebotCallEnabled,
        isPragueAirport,
        isPenam,
    } = useUserPermissions();
    const menuItems: Item[] = [];

    if (isCampaignsAdmin) {
        menuItems.push(MENU_OPTIONS[0]);
    }
    if (isMyBotsAdmin) {
        menuItems.push(MENU_OPTIONS[1]);
    }
    if (
        isCallAnalyticsEnabled ||
        isChatAnalyticsEnabled ||
        isSmsAnalyticsEnabled
    ) {
        menuItems.push(MENU_OPTIONS[2]);
    }
    if (isVoicebotCallEnabled) {
        menuItems.push(MENU_OPTIONS[3]);
    }
    if (isPragueAirport) {
        menuItems.push(MENU_OPTIONS[4]);
    }
    if (isPenam) {
        menuItems.push(MENU_OPTIONS[5]);
    }

    return (
        <>
            {menuItems.map((item) => (
                <NavItem
                    key={item.id}
                    item={item}
                    isNarrowBar={props.isNarrowBar}
                />
            ))}
        </>
    );
};

const NavItem: FC<{ item: Item; isNarrowBar: boolean }> = ({
    item,
    isNarrowBar,
}) => {
    const router = useRouter();
    const { t } = useTranslation();

    const Icon = item.icon;

    return (
        <SidebarItem
            icon={<Icon />}
            label={t(item.title)}
            isNarrowBar={isNarrowBar}
            disabled={item.disabled}
            selected={router.pathname.includes(item.url)}
            onClick={() => router.push(item.url)}
        />
    );
};
